import { Pencil } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import useLocationMediaList from "../../../containers/FacilityDetailsPage/hooks/useLocationMediaList";
import { RecentMediaList } from "../../DashboardComponents/RecentMediaList";

import "./styles.scss";

interface IRecentMediaUploadsSectionProps {
  locationId: string;
}

export const RecentMediaUploadsSection: React.FunctionComponent<
  IRecentMediaUploadsSectionProps
> = ({ locationId }) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityDetailsPage.recentMediaUploads.${key}`);
  const history = useHistory();

  const { data } = useLocationMediaList(locationId);
  const recentMediaList = data ?? [];

  const handleViewMore = () => {
    history.push(`/location/${locationId}/media`);
  };

  const handlePost = () => {
    alert(t("post_not_implemented"));
  };

  return (
    <div className="recent-media-uploads-container">
      <RecentMediaList
        dataList={recentMediaList.slice(0, 5)}
        hideLocationName
      />
      <div className="media-uploads-button-group">
        {recentMediaList.length > 0 && (
          <button className="btn btn-border" onClick={handleViewMore}>
            {t("view_more")}
          </button>
        )}
        <button className="btn btn-blue btn-new-media" onClick={handlePost}>
          <Pencil size={16} color="white" className="pencil-icon" />
          {t("post")}
        </button>
      </div>
    </div>
  );
};

export default RecentMediaUploadsSection;
